export default __webpack_public_path__ + "static/media/required.48c5603a.svg";